// Libraries
var React = require('react');

// Components
var VideoModule = require('./VideoModule');

class VideoModuleOneHotspur extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<section class="c-video-one-hotspur c-section c-section--one-hotspur">
				<VideoModule data={this.props.data} />
			</section>
		)
	}
}

module.exports = VideoModuleOneHotspur;



// WEBPACK FOOTER //
// ./src/components/Video/VideoModuleOneHotspur.js